import React, {Fragment, useContext} from "react";
import Translate from "../Translate";
import {TranslateContext} from "../../context/TranslateContext";
import {Link} from "react-router-dom";

export default function NsButtonAction({
                                           label,
                                           icona,
                                           href,
                                           disabled = false,
                                           type = "button",
                                           onClick = () => {
                                           },
                                       }) {

    const {translate} = useContext(TranslateContext);

    return (
        <Fragment>
            {
                href ?
                    <Link to={href}
                          className="dropdown-item"
                          data-toggle="tooltip" title={label}>
                        <i className={icona}/>
                        <Translate>{label}</Translate>
                    </Link>
                    :
                    <button
                        type={type}
                        className="dropdown-item"
                        disabled={disabled}
                        data-toggle="tooltip" title={translate(label)}
                        onClick={onClick}>
                        <i className={icona}/>
                        <Translate>{label}</Translate>
                    </button>
            }
        </Fragment>
    )
}